import React, { useState, useEffect } from "react";
import {
  Container, Row, Col, Card, Navbar, Nav,
  Form, Button, Alert, Modal, Spinner
} from "react-bootstrap";
import {
  FaFileUpload, FaEye, FaDownload, FaCheckCircle,
  FaClipboardList, FaFileCsv, FaFileAlt, FaMobileAlt, FaLink, FaApple, FaChevronRight, FaChevronDown, FaChevronLeft, FaUsers, FaThumbsUp
} from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";
import { FaUpload } from "react-icons/fa";
import { FedaCheckoutButton } from 'fedapay-reactjs';

/* ─── Styles globaux (inchangés) ─── */
const GLOBAL_CSS = `
@import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,700;9..144,800&family=Plus+Jakarta+Sans:wght@400;500;600&display=swap');

:root {
  --cf-blue:      #004aad;
  --cf-purple:    #764ba2;
  --cf-grad:      linear-gradient(135deg, #004aad 0%, #764ba2 100%);
  --cf-grad-soft: linear-gradient(135deg, #eef3ff 0%, #f5eeff 100%);
  --cf-surface:   #f7f8fc;
  --cf-border:    #e4e7f0;
  --cf-text:      #18192a;
  --cf-muted:     #6b7280;
  --cf-success:   #10b981;
  --cf-radius:    14px;
  --cf-radius-sm: 8px;
}

*, *::before, *::after { box-sizing: border-box; }

body { font-family: 'Plus Jakarta Sans', sans-serif; color: var(--cf-text); background: #fff; }

.cf-navbar {
  background: #fff !important;
  border-bottom: 1px solid var(--cf-border);
  padding: 0.6rem 0;
}
.cf-brand {
  font-family: 'Fraunces', serif;
  font-weight: 800;
  font-size: clamp(1.2rem, 4vw, 1.45rem);
  background: var(--cf-grad);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.5px;
}
.cf-nav-link {
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--cf-muted) !important;
  padding: 0.4rem 0.9rem !important;
  border-radius: 20px;
  transition: background 0.18s, color 0.18s;
}
.cf-nav-link:hover { background: var(--cf-surface); color: var(--cf-blue) !important; }

.cf-hero {
  background: var(--cf-grad);
  padding: clamp(2.5rem, 7vw, 4.5rem) 1.5rem;
  position: relative;
  overflow: hidden;
}
.cf-hero::before {
  content: '';
  position: absolute;
  width: 600px; height: 600px;
  border-radius: 50%;
  background: rgba(255,255,255,0.05);
  top: -200px; right: -150px;
  pointer-events: none;
}
.cf-hero::after {
  content: '';
  position: absolute;
  width: 300px; height: 300px;
  border-radius: 50%;
  background: rgba(255,255,255,0.06);
  bottom: -100px; left: -80px;
  pointer-events: none;
}
.cf-hero-title {
  font-family: 'Fraunces', serif;
  font-weight: 800;
  font-size: clamp(1.5rem, 5.5vw, 2.4rem);
  color: #fff;
  letter-spacing: -0.5px;
  line-height: 1.2;
  margin-bottom: 0.5rem;
}
.cf-hero-sub {
  color: rgba(255,255,255,0.78);
  font-size: clamp(0.85rem, 3vw, 1rem);
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 400;
}

.cf-info-banner {
  background: var(--cf-grad-soft);
  border: 1px solid var(--cf-border);
  border-radius: var(--cf-radius);
  padding: 1.25rem 1.5rem;
  font-size: clamp(0.78rem, 3vw, 0.9rem);
  line-height: 1.75;
  text-align: left;
}
.cf-info-banner ul { padding-left: 1.25rem; margin-bottom: 0.6rem; }
.cf-info-banner li { margin-bottom: 0.2rem; }
.cf-info-banner .badge-info { background: #dbeafe; color: #1d4ed8; border-radius: 4px; padding: 2px 7px; font-size: 0.75rem; font-weight: 500; }
.cf-info-banner .badge-ok   { background: #d1fae5; color: #065f46; border-radius: 4px; padding: 2px 7px; font-size: 0.75rem; font-weight: 500; }

.cf-zero-perte {
  font-weight: 700;
  color: #059669;
}

.cf-section-title {
  font-family: 'Fraunces', serif;
  font-weight: 700;
  font-size: clamp(1.05rem, 4vw, 1.35rem);
  color: var(--cf-blue);
  letter-spacing: -0.3px;
  text-align: center;
  margin-bottom: 1.5rem;
}

.cf-step-card {
  background: #fff;
  border: 1px solid var(--cf-border);
  border-radius: var(--cf-radius);
  padding: 1.1rem 0.9rem;
  text-align: center;
  transition: box-shadow 0.2s, transform 0.2s;
  height: 100%;
}
.cf-step-card:hover { box-shadow: 0 8px 28px rgba(0,74,173,0.1); transform: translateY(-2px); }
.cf-step-icon {
  width: clamp(44px, 10vw, 54px);
  height: clamp(44px, 10vw, 54px);
  border-radius: 50%;
  background: var(--cf-grad);
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 0.75rem;
}
.cf-step-label {
  font-family: 'Fraunces', serif;
  font-weight: 700;
  font-size: clamp(0.78rem, 3.5vw, 0.9rem);
  color: var(--cf-blue);
}
.cf-step-desc {
  font-size: clamp(0.7rem, 3vw, 0.82rem);
  color: var(--cf-muted);
  margin-bottom: 0.6rem;
}
.cf-chevron {
  position: absolute;
  right: -18px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  color: var(--cf-blue);
}

.cf-upload-card {
  background: #fff;
  border: 1.5px dashed var(--cf-border);
  border-radius: var(--cf-radius);
  padding: 2rem 1.5rem;
  text-align: center;
  transition: border-color 0.2s;
}
.cf-upload-card:hover { border-color: var(--cf-blue); }
.cf-file-input { max-width: 320px; margin: 0 auto; }

.cf-btn-primary {
  background: var(--cf-grad);
  border: none;
  border-radius: 30px;
  color: #fff;
  font-weight: 600;
  font-size: 0.9rem;
  padding: 0.5rem 1.6rem;
  transition: opacity 0.18s, transform 0.15s;
}
.cf-btn-primary:hover:not(:disabled) { opacity: 0.9; transform: translateY(-1px); color: #fff; }
.cf-btn-primary:disabled { opacity: 0.6; }

.cf-btn-outline {
  background: transparent;
  border: 1.5px solid var(--cf-blue);
  border-radius: 30px;
  color: var(--cf-blue);
  font-weight: 600;
  font-size: 0.82rem;
  padding: 0.35rem 1.1rem;
  transition: background 0.18s, color 0.18s;
}
.cf-btn-outline:hover { background: var(--cf-blue); color: #fff; }

.cf-btn-success {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border: none;
  border-radius: 30px;
  color: #fff;
  font-weight: 600;
  font-size: 0.82rem;
  padding: 0.35rem 1.1rem;
  transition: opacity 0.18s;
}
.cf-btn-success:hover:not(:disabled) { opacity: 0.88; color: #fff; }

.cf-contact-card {
  background: #fff;
  border: 1px solid var(--cf-border);
  border-radius: var(--cf-radius-sm);
  padding: 0.75rem 0.9rem;
  height: 100%;
  transition: box-shadow 0.15s;
}
.cf-contact-card:hover { box-shadow: 0 4px 16px rgba(0,74,173,0.08); }
.cf-contact-name {
  font-weight: 600;
  font-size: 0.82rem;
  color: var(--cf-blue);
  margin-bottom: 0.3rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cf-contact-old { font-size: 0.72rem; color: var(--cf-muted); margin-bottom: 0.1rem; }
.cf-contact-new { font-size: 0.72rem; color: var(--cf-success); font-weight: 500; }

.cf-download-banner {
  background: linear-gradient(135deg, #eef3ff 0%, #f0ebff 100%);
  border: 1px solid #c7d7fb;
  border-radius: var(--cf-radius);
  padding: 1.1rem 1.25rem;
  text-align: center;
}
.cf-download-count { font-family: 'Fraunces', serif; font-size: 1.5rem; font-weight: 800; color: var(--cf-blue); }
.cf-download-label { font-size: 0.82rem; color: var(--cf-muted); }
.cf-format-hint { font-size: 0.72rem; color: var(--cf-muted); margin-top: 0.5rem; }

.cf-global-counter {
  background: var(--cf-grad-soft);
  border: 1px solid var(--cf-border);
  border-radius: var(--cf-radius);
  padding: 1rem 1.5rem;
  text-align: center;
  margin: 1.5rem auto;
  max-width: 440px;
}
.cf-global-counter-icon {
  font-size: 1.5rem;
  margin-right: 0.5rem;
}
.cf-global-counter-number {
  font-family: 'Fraunces', serif;
  font-size: 1.8rem;
  font-weight: 800;
  color: var(--cf-blue);
}
.cf-global-counter-text {
  font-size: 0.85rem;
  color: var(--cf-muted);
  margin-top: 0.25rem;
}

.cf-like-btn {
  background: none;
  border: 1.5px solid #c7d7fb;
  border-radius: 30px;
  cursor: pointer;
  padding: 0.3rem 0.9rem;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--cf-blue);
  transition: background 0.18s, color 0.18s, transform 0.15s;
  margin-top: 0.5rem;
}
.cf-like-btn:hover:not(:disabled) {
  background: var(--cf-blue);
  color: #fff;
  transform: scale(1.05);
}
.cf-like-btn:disabled {
  opacity: 0.7;
  cursor: default;
}
.cf-like-btn.liked {
  background: var(--cf-blue);
  color: #fff;
}

.cf-modal .modal-header { border-bottom: 1px solid var(--cf-border); padding: 1rem 1.25rem; }
.cf-modal .modal-title { font-family: 'Fraunces', serif; font-weight: 700; font-size: clamp(0.95rem, 4vw, 1.15rem); color: var(--cf-blue); }
.cf-modal .modal-footer { border-top: 1px solid var(--cf-border); }
.cf-instr-box {
  background: var(--cf-surface);
  border-radius: var(--cf-radius-sm);
  padding: 1rem 1.1rem;
  font-size: clamp(0.72rem, 3vw, 0.84rem);
  line-height: 1.7;
}
.cf-instr-box h6 {
  font-family: 'Fraunces', serif;
  font-weight: 700;
  font-size: 0.85rem;
  color: var(--cf-blue);
  margin-bottom: 0.4rem;
}
.cf-instr-box ul { padding-left: 1.15rem; margin-bottom: 0.5rem; }
.cf-instr-box code {
  background: #e8ecf5;
  border-radius: 4px;
  padding: 1px 5px;
  font-size: 0.78rem;
  color: var(--cf-blue);
}

.cf-footer {
  background: var(--cf-surface);
  border-top: 1px solid var(--cf-border);
  padding: 1.5rem;
  text-align: center;
  font-size: 0.8rem;
  color: var(--cf-muted);
}

@media (max-width: 576px) {
  .cf-hero { padding: 2rem 1rem; }
  .cf-step-card { padding: 0.8rem 0.6rem; }
}
`;

// ==================== DÉTECTION D'ENCODAGE ====================
function detectEncoding(buffer) {
  const bytes = new Uint8Array(buffer);
  // BOM detection
  if (bytes.length >= 3 && bytes[0] === 0xEF && bytes[1] === 0xBB && bytes[2] === 0xBF) {
    return 'UTF-8';
  }
  if (bytes.length >= 2 && bytes[0] === 0xFF && bytes[1] === 0xFE) {
    return 'UTF-16LE';
  }
  if (bytes.length >= 2 && bytes[0] === 0xFE && bytes[1] === 0xFF) {
    return 'UTF-16BE';
  }
  // Tentative de décodage UTF-8 (avec échec fatal)
  try {
    new TextDecoder('UTF-8', { fatal: true }).decode(buffer);
    return 'UTF-8';
  } catch {
    // Fallback : ISO-8859-1 (Latin1)
    return 'ISO-8859-1';
  }
}

// ==================== CONSTANTES ET FONCTIONS ====================
const mtnPrefixes   = ["42","46","50","51","52","53","54","56","57","59","61","62","66","67","69","90","91","96","97"];
const moovPrefixes  = ["45","55","58","60","63","64","65","68","94","95","98","99"];
const celtisPrefixes= ["20","21","22","23","24","28","29","40","41","43","44","47","48","49","92","93"];
const validPrefixes = [...mtnPrefixes, ...moovPrefixes, ...celtisPrefixes];

function getOperator(prefix) {
  if (mtnPrefixes.includes(prefix))    return "MTN";
  if (moovPrefixes.includes(prefix))   return "Moov";
  if (celtisPrefixes.includes(prefix)) return "Celtis";
  return "Inconnu";
}

function normalizeBeninPhone(raw) {
  let s = String(raw).replace(/[\s\-().]/g, "");
  if (/^\+?2290[12]\d{8}$/.test(s)) return null;
  if (/^00229\d{10}$/.test(s))      return null;
  if (s.startsWith("+229"))   s = s.slice(4);
  else if (s.startsWith("00229")) s = s.slice(5);
  else if (s.startsWith("229") && s.length === 11) s = s.slice(3);
  // Ignorer les numéros déjà au format 01/02 + 8 chiffres
  if (/^0[12]\d{8}$/.test(s)) return null;
  if (/^\d{8}$/.test(s) && validPrefixes.includes(s.slice(0, 2))) return s;
  return null;
}

function formatOldNumber(raw) {
  let s = String(raw).replace(/[\s\-().]/g, "");
  if (s.startsWith("+229") || s.startsWith("00229")) return raw.trim();
  if (/^\d{8}$/.test(s) && validPrefixes.includes(s.slice(0, 2))) return `+229${s}`;
  if (/^229\d{8}$/.test(s)) return `+${s}`;
  return raw.trim();
}

// ================== DÉCODEUR QUOTED-PRINTABLE (avec jeu de caractères) ==================
function decodeQuotedPrintable(str, charset = 'UTF-8') {
  str = str.replace(/=\r?\n/g, '');
  const bytes = [];
  let i = 0;
  while (i < str.length) {
    if (str[i] === '=' && i + 2 < str.length && /[0-9A-F]{2}/i.test(str.substring(i + 1, i + 3))) {
      const hex = str.substring(i + 1, i + 3);
      bytes.push(parseInt(hex, 16));
      i += 3;
    } else {
      bytes.push(str.charCodeAt(i));
      i++;
    }
  }
  try {
    const decoder = new TextDecoder(charset);
    return decoder.decode(new Uint8Array(bytes));
  } catch {
    // Fallback UTF-8
    const decoder = new TextDecoder('UTF-8');
    return decoder.decode(new Uint8Array(bytes));
  }
}

// ================== EXTRACTION DU NOM AVEC DÉCODAGE ==================
function extractName(lines) {
  function getDecodedValue(line) {
    const colonIdx = line.indexOf(':');
    if (colonIdx === -1) return null;
    let raw = line.substring(colonIdx + 1).trim();
    // Extraire le jeu de caractères s'il est présent
    let charset = 'UTF-8';
    const charsetMatch = line.match(/CHARSET=([^;:]+)/i);
    if (charsetMatch) charset = charsetMatch[1];
    if (line.toUpperCase().includes('ENCODING=QUOTED-PRINTABLE')) {
      raw = decodeQuotedPrintable(raw, charset);
    }
    return raw;
  }

  for (const line of lines) {
    const trimmed = line.trim();
    if (trimmed.startsWith('FN')) {
      const decoded = getDecodedValue(trimmed);
      if (decoded) {
        return decoded.replace(/\uFFFD/g, '').replace(/;+$/, '').trim();
      }
    }
  }
  for (const line of lines) {
    const trimmed = line.trim();
    if (trimmed.startsWith('N')) {
      const decoded = getDecodedValue(trimmed);
      if (decoded) {
        const parts = decoded.split(';');
        const lastName = parts[0] || '';
        const firstName = parts[1] || '';
        const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();
        if (fullName) return fullName;
      }
    }
  }
  return 'Sans nom';
}

// ================== PROCESS CSV (amélioré – détection automatique) ==================
function processCSV(content, maxModifications = Infinity) {
  const lines = content.split(/\r?\n/);
  if (lines.length < 2) return { updatedNumbers: [], newContent: content, allContactsDetails: [], modifiedContactsDetails: [] };

  const originalHeaders = lines[0].split(",").map(h => h.trim().replace(/^"|"$/g, ""));
  
  // Détecter les colonnes de téléphone (Phone 1 - Value, Phone 2 - Value, ...)
  const phoneValueIdxs = originalHeaders.reduce((acc, h, i) => {
    if (/^Phone \d+ - Value$/i.test(h)) acc.push(i);
    return acc;
  }, []);
  
  // Détecter les colonnes de nom (en français ou anglais)
  const firstNameIdx = originalHeaders.findIndex(h => /^(Prénom|First Name)$/i.test(h));
  const lastNameIdx  = originalHeaders.findIndex(h => /^(Nom|Last Name)$/i.test(h));
  const orgIdx       = originalHeaders.findIndex(h => /^(Organization Name|Organisation)$/i.test(h));
  const nickIdx      = originalHeaders.findIndex(h => /^(Nickname|Surnom)$/i.test(h));
  
  // Construire les nouveaux en‑têtes (avec colonnes "Old Value")
  const newHeaders = [];
  for (let i = 0; i < originalHeaders.length; i++) {
    newHeaders.push(originalHeaders[i]);
    if (phoneValueIdxs.includes(i)) {
      const oldHeader = originalHeaders[i].replace(/Value$/, "Old Value");
      newHeaders.push(oldHeader);
    }
  }
  
  const updatedNumbers = [];
  const allContactsDetails = [];
  const modifiedContactsDetails = [];
  const newLines = [newHeaders.map(h => (h.includes(",") || h.includes('"') ? `"${h.replace(/"/g, '""')}"` : h)).join(",")];
  
  let modificationsDone = 0;

  for (let i = 1; i < lines.length; i++) {
    const line = lines[i];
    if (!line.trim()) { newLines.push(line); continue; }
    let cols = parseCSVLine(line);
    while (cols.length < newHeaders.length) cols.push("");
    
    const firstName = getCol(cols, firstNameIdx);
    const lastName  = getCol(cols, lastNameIdx);
    const org       = getCol(cols, orgIdx);
    const nick      = getCol(cols, nickIdx);
    const fullName = [firstName, lastName].filter(Boolean).join(" ").trim() || org || nick || "Sans nom";
    
    const contact = {
      firstName,
      lastName,
      org,
      nickname: nick,
      phones: []
    };
    let hasModification = false;
    
    for (let vi of phoneValueIdxs) {
      if (modificationsDone >= maxModifications) break;
      const rawPhone = getCol(cols, vi);
      if (!rawPhone) continue;
      
      const clean8 = normalizeBeninPhone(rawPhone);
      if (clean8) {
        const newPhone = `+22901${clean8}`;
        const oldFormatted = formatOldNumber(rawPhone);
        const op = getOperator(clean8.slice(0, 2));
        
        contact.phones.push({ type: 'old', value: oldFormatted });
        contact.phones.push({ type: `N° ${op}`, value: newPhone });
        
        updatedNumbers.push({
          name: fullName,
          oldNumber: oldFormatted,
          newNumber: newPhone
        });
        
        const oldColIndex = newHeaders.findIndex((h, idx) => idx > vi && h === originalHeaders[vi].replace(/Value$/, "Old Value"));
        if (oldColIndex !== -1 && oldColIndex < cols.length) {
          cols[oldColIndex] = oldFormatted;
        }
        cols[vi] = newPhone;
        hasModification = true;
        modificationsDone++;
      } else {
        // Numéro non convertible – on le garde tel quel
        contact.phones.push({ type: 'CELL', value: rawPhone.trim() });
        const oldColIndex = newHeaders.findIndex((h, idx) => idx > vi && h === originalHeaders[vi].replace(/Value$/, "Old Value"));
        if (oldColIndex !== -1 && !cols[oldColIndex]) cols[oldColIndex] = "";
      }
    }
    
    allContactsDetails.push(contact);
    if (hasModification) {
      modifiedContactsDetails.push(contact);
    }
    
    newLines.push(cols.map(c => (c.includes(",") || c.includes('"') ? `"${c.replace(/"/g, '""')}"` : c)).join(","));
  }
  
  return {
    updatedNumbers,
    newContent: newLines.join("\n"),
    allContactsDetails,
    modifiedContactsDetails
  };
}

// ================== GENERATION VCF DEPUIS CONTACTS DÉTAILLÉS ==================
function generateVCFFromDetails(contacts) {
  let vcf = '';
  contacts.forEach(contact => {
    const { firstName, lastName, org, nickname, phones } = contact;
    const fullName = [firstName, lastName].filter(Boolean).join(' ').trim() || 'Sans nom';
    
    vcf += 'BEGIN:VCARD\r\n';
    vcf += 'VERSION:3.0\r\n';
    // FN
    vcf += `FN;CHARSET=UTF-8:${fullName}\r\n`;
    // N
    vcf += `N;CHARSET=UTF-8:${lastName || ''};${firstName || ''};;;\r\n`;
    // ORG
    if (org) vcf += `ORG;CHARSET=UTF-8:${org}\r\n`;
    // NICKNAME
    if (nickname) vcf += `NICKNAME;CHARSET=UTF-8:${nickname}\r\n`;
    // TEL
    phones.forEach(phone => {
      const clean = phone.value.replace(/[\s\-()]/g, '');
      if (phone.type === 'old') {
        vcf += `TEL;TYPE=HOME:${clean}\r\n`;
      } else if (phone.type.startsWith('N°')) {
        vcf += `TEL;TYPE=CELL;TYPE=PREF:${clean}\r\n`;
      } else {
        vcf += `TEL;TYPE=${phone.type}:${clean}\r\n`;
      }
    });
    vcf += 'END:VCARD\r\n';
  });
  return vcf;
}

// ================== PROCESS VCF (CORRIGÉ AVEC DÉCODAGE ET DÉTECTION 01 UNIQUEMENT) ==================
function processVCF(content, maxModifications = Infinity) {
  const updatedNumbers = [];
  const allNumbers = [];
  let modificationsDone = 0;

  const cleaned = content.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  const blocks = cleaned.split(/(?=BEGIN:VCARD)/).filter(b => b.trim().startsWith('BEGIN:VCARD'));

  const processedBlocks = blocks.map(block => {
    if (modificationsDone >= maxModifications) return block;

    const lines = block.split('\n');
    const telLines = [];
    const otherLines = [];
    let endLine = 'END:VCARD';

    for (const line of lines) {
      const trimmed = line.trim();
      if (trimmed === '') continue;
      if (trimmed.startsWith('TEL')) {
        telLines.push(line);
      } else if (trimmed.startsWith('END:VCARD')) {
        endLine = line;
      } else {
        otherLines.push(line);
      }
    }

    // --- Décoder les lignes N et FN encodées en Quoted-Printable avec leur charset ---
    const decodedOtherLines = otherLines.map(line => {
      const upper = line.toUpperCase();
      if ((upper.startsWith('N') || upper.startsWith('FN')) && upper.includes('ENCODING=QUOTED-PRINTABLE')) {
        const colonIdx = line.indexOf(':');
        if (colonIdx !== -1) {
          const encodedValue = line.substring(colonIdx + 1);
          // Extraire le charset
          let charset = 'UTF-8';
          const charsetMatch = line.match(/CHARSET=([^;:]+)/i);
          if (charsetMatch) charset = charsetMatch[1];
          let decoded = decodeQuotedPrintable(encodedValue, charset);
          decoded = decoded.replace(/\uFFFD/g, '').trim();
          const fieldName = line.trim().startsWith('N') ? 'N' : 'FN';
          return `${fieldName}:${decoded}`;
        }
      }
      return line;
    });

    // ---------- DÉTECTION SI DÉJÀ CONVERTI (uniquement 01) ----------
    let alreadyConverted = false;
    for (const tel of telLines) {
      const colonIdx = tel.indexOf(':');
      if (colonIdx === -1) continue;
      const rawPhone = tel.substring(colonIdx + 1).trim();
      const clean = rawPhone.replace(/[\s\-().]/g, '');
      // Reconnaît : 01XXXXXXXX, +22901XXXXXXXX, 0022901XXXXXXXX
      if (/^(01\d{8}|\+22901\d{8}|0022901\d{8})$/.test(clean)) {
        alreadyConverted = true;
        break;
      }
    }
    if (alreadyConverted) return block;

    // Conversion
    const newTelLines = [];
    const existingNew = new Set();

    for (const tel of telLines) {
      const colonIdx = tel.indexOf(':');
      if (colonIdx === -1) continue;
      const rawPhone = tel.substring(colonIdx + 1).trim();

      const alreadyNew = rawPhone.match(/^\+22901(\d{8})$/);
      if (alreadyNew) {
        existingNew.add(alreadyNew[1]);
        continue;
      }

      if (/type=old/i.test(tel)) continue;
      if (modificationsDone >= maxModifications) continue;

      const clean8 = normalizeBeninPhone(rawPhone);
      if (clean8 && !existingNew.has(clean8)) {
        const op = getOperator(clean8.slice(0, 2));
        const oldFormatted = formatOldNumber(rawPhone);
        const newPhone = `+22901${clean8}`;
        newTelLines.push(`TEL;TYPE=old:${oldFormatted}`);
        newTelLines.push(`TEL;TYPE=N° ${op}:${newPhone}`);
        const name = extractName(lines);
        allNumbers.push({ name, oldNumber: rawPhone });
        updatedNumbers.push({
          name,
          oldNumber: oldFormatted,
          newNumber: newPhone
        });
        modificationsDone++;
        existingNew.add(clean8);
      }
    }

    const allLines = [
      ...decodedOtherLines,
      ...newTelLines,
      endLine
    ];
    return allLines.join('\n');
  });

  return {
    updatedNumbers,
    newContent: processedBlocks.join('\n'),
    allNumbers
  };
}

// ================== FONCTIONS UTILITAIRES ==================
function parseCSVLine(line) {
  const result = [];
  let cur = "";
  let inQ = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (ch === '"') {
      if (inQ && line[i+1] === '"') { cur += '"'; i++; }
      else inQ = !inQ;
    } else if (ch === ',' && !inQ) {
      result.push(cur); cur = "";
    } else {
      cur += ch;
    }
  }
  result.push(cur);
  return result;
}

function getCol(cols, idx) {
  if (idx < 0 || idx >= cols.length) return "";
  return (cols[idx] || "").trim().replace(/^"|"$/g, "");
}

// ================== GÉNÉRATION VCF (pour CSV) ==================
function generateVCF(contacts) {
  let vcf = '';
  contacts.forEach(contact => {
    const name = (contact.name || 'Sans nom').replace(/[,;]/g, '').trim();
    vcf += 'BEGIN:VCARD\r\n';
    vcf += 'VERSION:3.0\r\n';
    vcf += `FN:${name}\r\n`;
    if (contact.oldNumber) {
      const oldClean = contact.oldNumber.replace(/[\s\-]/g, '');
      vcf += `TEL;TYPE=HOME:${oldClean}\r\n`;
    }
    if (contact.newNumber) {
      const newClean = contact.newNumber.replace(/[\s\-]/g, '');
      vcf += `TEL;TYPE=CELL:${newClean}\r\n`;
    } else if (contact.oldNumber) {
      const oldClean = contact.oldNumber.replace(/[\s\-]/g, '');
      vcf += `TEL;TYPE=CELL:${oldClean}\r\n`;
    }
    vcf += 'END:VCARD\r\n';
  });
  return vcf;
}

function getFirst50Contacts(sortedPreviewData) {
  return sortedPreviewData.filter(c => c.newNumber).slice(0, 50);
}

// ==================== COMPOSANT PRINCIPAL ====================
export default function App() {
  const [fileContent, setFileContent]           = useState("");
  const [previewData, setPreviewData]           = useState([]);
  const [modificationCount, setModificationCount] = useState(0);
  const [file, setFile]                         = useState(null);
  const [fileType, setFileType]                 = useState("");
  const [showModal, setShowModal]               = useState(false);
  const [showModal1, setShowModal1]             = useState(false);
  const [isAnalyzing, setIsAnalyzing]           = useState(false);
  const [showDownloadOptions, setShowDownloadOptions] = useState(false);
  const [processedContent, setProcessedContent] = useState("");
  const [processedFileName, setProcessedFileName] = useState("");
  const [sortedPreviewData, setSortedPreviewData] = useState([]);
  const [originalFileContent, setOriginalFileContent] = useState("");
  const [showAllPreview, setShowAllPreview]           = useState(false);
  const [hasAnalyzed, setHasAnalyzed]                 = useState(false);

  // Nouveaux states pour les contacts détaillés (CSV)
  const [allContactsDetails, setAllContactsDetails] = useState([]);
  const [modifiedContactsDetails, setModifiedContactsDetails] = useState([]);

  const [globalCount, setGlobalCount] = useState(142);
  const [isLoadingCount, setIsLoadingCount] = useState(true);
  const [likeCount, setLikeCount] = useState(0);
  const [isLoadingLikes, setIsLoadingLikes] = useState(true);
  const [hasLiked, setHasLiked] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);

  const GOOGLE_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbxFGy-RhMN-42U6OGNfR4Pt7QKxA66vQg_LJQ6elZ4pPVGHN82OV87-xwVsYh-4kmQ3/exec";
  const LIKES_SCRIPT_URL  = "https://script.google.com/macros/s/AKfycbxFGy-RhMN-42U6OGNfR4Pt7QKxA66vQg_LJQ6elZ4pPVGHN82OV87-xwVsYh-4kmQ3/exec";

  const handleCloseModal  = () => setShowModal(false);
  const handleCloseModal1 = () => setShowModal1(false);
  const handleCloseModal2 = () => setShowModal2(false);
  const handleCloseModal3 = () => setShowModal3(false);

  const [hasConfirmedView, setHasConfirmedView] = useState(false);

  // --- COMPTEURS ---
  const loadGlobalCount = async () => {
    try {
      const response = await fetch(`${GOOGLE_SCRIPT_URL}?action=get`);
      const data = await response.json();
      if (data && data.count !== undefined) setGlobalCount(data.count);
    } catch (error) {
      console.error("Erreur chargement compteur:", error);
      setGlobalCount(142);
    } finally {
      setIsLoadingCount(false);
    }
  };

  const incrementGlobalCounter = async () => {
    try {
      const response = await fetch(`${GOOGLE_SCRIPT_URL}?action=increment`);
      const data = await response.json();
      if (data && data.count !== undefined) setGlobalCount(data.count);
    } catch (error) {
      console.error("Erreur incrémentation:", error);
      setGlobalCount(prev => prev + 1);
    }
  };

  const loadLikeCount = async () => {
    try {
      const response = await fetch(`${LIKES_SCRIPT_URL}?action=getLikes`);
      const data = await response.json();
      if (data && data.likes !== undefined) setLikeCount(data.likes);
    } catch (error) {
      console.error("Erreur chargement likes:", error);
    } finally {
      setIsLoadingLikes(false);
    }
  };

  const incrementLikeCounter = async () => {
    setLikeCount(prev => prev + 1);
    try {
      await fetch(`${LIKES_SCRIPT_URL}?action=incrementLikes`);
    } catch (error) {
      console.error("Erreur like:", error);
    }
  };

  const handleLike = () => {
    if (hasLiked) return;
    setHasLiked(true);
    incrementLikeCounter();
  };

  useEffect(() => {
    loadGlobalCount();
    loadLikeCount();
  }, []);

  useEffect(() => {
    if (showAllPreview && previewData.length > 3) {
      const confirmEl = document.getElementById("confirm-section");
      if (confirmEl) confirmEl.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [showAllPreview, previewData.length]);

  useEffect(() => {
    if (!showAllPreview && previewData.length > 3) {
      setHasConfirmedView(false);
    }
  }, [showAllPreview, previewData.length]);

  // --- GESTION FICHIER AVEC DÉTECTION D'ENCODAGE ---
  const handleFileChange = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    setFile(f);
    setPreviewData([]);
    setModificationCount(0);
    setProcessedContent("");
    setShowDownloadOptions(false);
    setHasAnalyzed(false);
    const ext = f.name.split(".").pop().toLowerCase();
    if (!["csv", "vcf"].includes(ext)) {
      Swal.fire({ icon: "error", title: "Format invalide", text: "Seuls .csv et .vcf sont acceptés.", confirmButtonColor: "#004aad" });
      return;
    }
    setFileType(ext);
    const reader = new FileReader();
    reader.onload = (ev) => {
      const buffer = ev.target.result;
      // Détection automatique de l'encodage
      const encoding = detectEncoding(buffer);
      let content = new TextDecoder(encoding).decode(buffer);
      // Supprimer le BOM s'il est présent
      if (content.charCodeAt(0) === 0xFEFF) {
        content = content.slice(1);
      }
      setFileContent(content);
      setOriginalFileContent(content);
    };
    reader.readAsArrayBuffer(f);
  };

  const processFile = () => {
    if (!fileContent || !file) {
      Swal.fire({ icon: "error", title: "Aucun fichier", text: "Veuillez sélectionner un fichier.", confirmButtonColor: "#004aad" });
      return;
    }
    setIsAnalyzing(true);
    setTimeout(() => {
      try {
        const ext = file.name.split(".").pop().toLowerCase();
        let updatedNumbers, newContent;
        let allContactsDetails = [];
        let modifiedContactsDetails = [];
        
        if (ext === "csv") {
          const result = processCSV(fileContent);
          updatedNumbers = result.updatedNumbers;
          newContent = result.newContent;
          allContactsDetails = result.allContactsDetails;
          modifiedContactsDetails = result.modifiedContactsDetails;
          setAllContactsDetails(allContactsDetails);
          setModifiedContactsDetails(modifiedContactsDetails);
        } else {
          const result = processVCF(fileContent);
          updatedNumbers = result.updatedNumbers;
          newContent = result.newContent;
          setAllContactsDetails([]);
          setModifiedContactsDetails([]);
        }
        
        const sorted = [...updatedNumbers].sort((a, b) => a.name.localeCompare(b.name));
        setSortedPreviewData(sorted);
        setPreviewData(sorted);
        setShowAllPreview(false);
        setModificationCount(sorted.length);
        setProcessedContent(newContent);
        setProcessedFileName(`contacts_mis_a_jour.${ext}`);
        setIsAnalyzing(false);
        setShowDownloadOptions(true);
        setHasAnalyzed(true);
        setHasConfirmedView(false);
        if (sorted.length === 0) {
          Swal.fire({ icon: "info", title: "Aucun contact à modifier", text: "Tous les numéros du Bénin de votre répertoire sont déjà au format 10 chiffres, ou aucun numéro béninois n'a été trouvé.", confirmButtonColor: "#004aad" });
        } else {
          Swal.fire({ icon: "success", title: "Analyse terminée !", html: `<p>✅ ${sorted.length} contact${sorted.length > 1 ? "s" : ""} à modifier</p>`, confirmButtonText: "Continuer", confirmButtonColor: "#004aad" });
        }
      } catch (err) {
        console.error(err);
        setIsAnalyzing(false);
        Swal.fire({ icon: "error", title: "Erreur", text: "Erreur lors de l'analyse du fichier.", confirmButtonColor: "#004aad" });
      }
    }, 100);
  };

  const triggerDownload = (content, filename) => {
    const blob = new Blob([content], { type: "text/vcard;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename.endsWith(".vcf") ? filename : filename + ".vcf";
    document.body.appendChild(a);
    a.click();
    setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url); }, 500);
  };

  // ================== TÉLÉCHARGEMENT GRATUIT ==================
  const handleFreeDownload = () => {
    // Pour CSV : utiliser les contacts modifiés détaillés
    if (fileType === "csv") {
      const first50Modified = modifiedContactsDetails.slice(0, 50);
      if (first50Modified.length === 0) {
        Swal.fire({ icon: "info", title: "Aucun contact modifié", text: "Aucun contact modifié à télécharger.", confirmButtonColor: "#004aad" });
        return;
      }
      const vcfContent = generateVCFFromDetails(first50Modified);
      triggerDownload(vcfContent, 'contacts_gratuit_50.vcf');
      Swal.fire({ icon: "success", title: "Téléchargement réussi !", text: `${first50Modified.length} contacts modifiés téléchargés.`, confirmButtonColor: "#004aad" });
      incrementGlobalCounter();
      showPostDownloadPopup();
      return;
    }

    // Pour VCF : comportement existant
    const first50 = getFirst50Contacts(sortedPreviewData);
    if (first50.length === 0) {
      Swal.fire({ icon: "info", title: "Aucun contact modifié", text: "Aucun contact modifié à télécharger.", confirmButtonColor: "#004aad" });
      return;
    }

    if (fileType === "vcf") {
      const newNumbers = new Set(first50.map(c => c.newNumber));
      const blocks = processedContent.split(/(?=BEGIN:VCARD)/);
      const selectedBlocks = blocks.filter(block => {
        for (let num of newNumbers) {
          if (block.includes(num)) return true;
        }
        return false;
      });
      if (selectedBlocks.length === 0) {
        Swal.fire({ icon: "error", title: "Erreur", text: "Impossible d'extraire les contacts.", confirmButtonColor: "#004aad" });
        return;
      }
      const content = selectedBlocks.join("");
      triggerDownload(content, 'contacts_gratuit_50.vcf');
      Swal.fire({ icon: "success", title: "Téléchargement réussi !", text: `${selectedBlocks.length} contacts modifiés téléchargés.`, confirmButtonColor: "#004aad" });
    } else {
      const vcfContent = generateVCF(first50);
      triggerDownload(vcfContent, 'contacts_gratuit_50.vcf');
      Swal.fire({ icon: "success", title: "Téléchargement réussi !", text: `${first50.length} contacts modifiés téléchargés.`, confirmButtonColor: "#004aad" });
    }
    incrementGlobalCounter();
    showPostDownloadPopup();
  };

  // ================== TÉLÉCHARGEMENT COMPLET ==================
  const handleFullDownload = () => {
    // Pour CSV : utiliser tous les contacts détaillés
    if (fileType === "csv") {
      if (allContactsDetails.length === 0) {
        Swal.fire({ icon: "info", title: "Aucun contact", text: "Aucun contact à télécharger.", confirmButtonColor: "#004aad" });
        return;
      }
      const vcfContent = generateVCFFromDetails(allContactsDetails);
      triggerDownload(vcfContent, 'contacts_complets.vcf');
      Swal.fire({ icon: "success", title: "Tous vos contacts ont été téléchargés.", confirmButtonColor: "#004aad" });
      incrementGlobalCounter();
      showPostDownloadPopup();
      return;
    }

    // Pour VCF : comportement existant
    if (!processedContent) {
      Swal.fire({ icon: "error", title: "Erreur", text: "Aucun contenu traité disponible.", confirmButtonColor: "#004aad" });
      return;
    }
    const allContacts = sortedPreviewData.filter(c => c.newNumber);
    if (allContacts.length === 0) {
      Swal.fire({ icon: "info", title: "Aucun contact", text: "Aucun contact modifié.", confirmButtonColor: "#004aad" });
      return;
    }

    if (fileType === "vcf") {
      const blob = new Blob([processedContent], { type: "text/vcard;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = 'contacts_complets.vcf';
      document.body.appendChild(a);
      a.click();
      setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url); }, 500);
    } else {
      const vcfContent = generateVCF(allContacts);
      const blob = new Blob([vcfContent], { type: "text/vcard;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = 'contacts_complets.vcf';
      document.body.appendChild(a);
      a.click();
      setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url); }, 500);
    }
    Swal.fire({ icon: "success", title: "Tous vos contacts ont été téléchargés.", confirmButtonColor: "#004aad" });
    incrementGlobalCounter();
    showPostDownloadPopup();
  };

  const handleSuccessfulPayment = () => handleFullDownload();

  const showPostDownloadPopup = () => {
    Swal.fire({
      title: 'Mettez à jour vos contacts sur votre téléphone',
      html: `
        <div style="text-align: left; max-height: 60vh; overflow-y: auto; padding: 0.2rem 0;">
          <div style="display: flex; flex-wrap: wrap; gap: 1rem;">
            <!-- Android -->
            <div style="flex: 1 1 45%; min-width: 200px;">
              <h5 style="font-family: 'Fraunces', serif; font-weight: 700; font-size: 0.95rem; color: #10b981; margin-bottom: 0.6rem;">
                Android
              </h5>
              <div class="cf-instr-box">
                <ol style="padding-left: 1.2rem; margin-bottom: 0.5rem;">
                  <li>Ouvrez l'application <strong>Contacts</strong>.</li>
                  <li>Appuyez sur les <strong>⋮</strong> (3 points) ou <strong>Paramètres</strong>.</li>
                  <li>Choisissez <strong>Importer</strong> puis <strong>Depuis un fichier</strong> (ou "Depuis le stockage").</li>
                  <li>
                    Dans l'explorateur, ouvrez le dossier <strong>Téléchargements</strong>.<br />
                    <span style="color: var(--cf-muted); font-size: 0.85rem;">
                      ↳ C'est l'emplacement par défaut où votre fichier modifié a été sauvegardé.
                    </span>
                  </li>
                  <li>Sélectionnez votre fichier <code>.VCF</code> et validez l'importation.</li>
                </ol>
                <p style="font-size: 0.75rem; color: var(--cf-muted); margin-bottom: 0;">
                  <strong>Astuce :</strong> Les libellés peuvent varier selon les marques et modèles de téléphone, mais le chemin reste identique.
                </p>
              </div>
            </div>

            <!-- iOS -->
            <div style="flex: 1 1 45%; min-width: 200px;">
              <h5 style="font-family: 'Fraunces', serif; font-weight: 700; font-size: 0.95rem; color: #0ea5e9; margin-bottom: 0.6rem;">
                iOS
              </h5>
              <div class="cf-instr-box">
                <ol style="padding-left: 1.2rem; margin-bottom: 0.5rem;">
                  <li>
                    Ouvrez l'application <strong>Fichiers</strong> et accédez au dossier <strong>Téléchargements</strong>.<br />
                    <span style="color: var(--cf-muted); font-size: 0.85rem;">
                      ↳ C'est ici que votre fichier modifié a été sauvegardé par défaut.
                    </span>
                  </li>
                  <li>Cliquez sur le fichier <code>.VCF</code> pour ouvrir l'aperçu des contacts.</li>
                  <li>Appuyez sur <strong>"Ajouter tous les contacts"</strong> (en haut à droite) pour finaliser.</li>
                </ol>
                <p style="font-size: 0.75rem; color: var(--cf-muted); margin-bottom: 0;">
                  <strong>Astuce :</strong> Le format <code>.VCF</code> garantit un import fluide et sans erreur sur iPhone.
                </p>
              </div>
            </div>
          </div>
        </div>
      `,
      confirmButtonText: 'J’ai compris, merci !',
      confirmButtonColor: '#004aad',
      width: 700,
      padding: '1.2rem',
      backdrop: 'rgba(0,0,0,0.4)',
      customClass: {
        popup: 'cf-modal-popup'
      }
    });
  };

  const checkoutButtonOptions = {
    public_key: process.env.REACT_APP_FEDAPAY_PUBLIC_KEY || "pk_live_7hGEeGrLD348WRKcOI3i1Ej1",
    transaction: { amount: 700, description: "Contacts illimités (8 → 10 chiffres)" },
    currency: { iso: "XOF" },
    button: {
      class: "cf-btn-success",
      text: `Télécharger tout (${modificationCount} contacts) - 700 FCFA`
    },
    onComplete: (resp) => {
      const FedaPay = window['FedaPay'];
      if (resp.reason === FedaPay?.DIALOG_DISMISSED) {
        console.log("Paiement annulé");
        return;
      }

      const closeDialog = () => {
        try {
          const selectors = [
            '.fedapay-dialog',
            '.fedapay-modal',
            '.fedapay-overlay',
            '.fedapay-backdrop',
            '.fedapay-container',
            '[class*="fedapay"]',
            '#fedapay-dialog'
          ];
          selectors.forEach(selector => {
            document.querySelectorAll(selector).forEach(el => el.remove());
          });
          document.querySelectorAll('iframe[src*="fedapay"]').forEach(el => el.remove());
          document.body.style.overflow = '';
          document.body.style.paddingRight = '';
          const styleTags = document.querySelectorAll('style');
          styleTags.forEach(tag => {
            if (tag.textContent.includes('fedapay')) tag.remove();
          });
        } catch (e) {
          console.warn('Erreur lors de la fermeture du dialogue FedaPay', e);
        }
      };

      closeDialog();

      setTimeout(() => {
        handleSuccessfulPayment(); 
      }, 600);
    }
  };

  const steps = [
    { icon: <FaFileUpload size={22} color="#fff" />, label: "Étape 1", desc: "Ajoutez votre fichier ", btn: <button className="cf-btn-outline mt-1" onClick={() => setShowModal(true)} style={{ fontSize: "0.73rem", padding: "3px 12px" }}>Instructions</button> },
    { icon: <FaEye size={22} color="#fff" />,        label: "Étape 2", desc: "Consultez l'aperçu", btn: <button className="cf-btn-outline mt-1" onClick={() => setShowModal2(true)} style={{ fontSize: "0.73rem", padding: "3px 12px" }}>Instructions</button> },
    { icon: <FaDownload size={22} color="#fff" />,   label: "Étape 3", desc: "Téléchargez", btn: <button className="cf-btn-outline mt-1" onClick={() => setShowModal3(true)} style={{ fontSize: "0.73rem", padding: "3px 12px" }}>Instructions</button> },
    { icon: <FaClipboardList size={22} color="#fff" />, label: "Étape 4", desc: "Importer les contacts modifiés dans votre téléphone", btn: <button className="cf-btn-outline mt-1" onClick={() => setShowModal1(true)} style={{ fontSize: "0.73rem", padding: "3px 12px" }}>Instructions</button> },
  ];

  // ==================== RENDU ====================
  return (
    <>
      <style>{GLOBAL_CSS}</style>

      <Navbar className="cf-navbar shadow-none" expand="lg">
        <Container fluid className="px-3 px-md-4">
          <Navbar.Brand href="https://cinnuex.com/" className="d-flex align-items-center gap-2">
            <img
              src="/logo-cinnuex.png"
              alt="CINNUEX"
              style={{ height: 50, width: "auto", objectFit: "contain" }}
            />
          </Navbar.Brand>
          <span className="cf-brand">ContactFlow</span>
          <Navbar.Toggle aria-controls="cf-nav" style={{ border: "none", boxShadow: "none" }} />
          <Navbar.Collapse id="cf-nav">
            <Nav className="ms-auto gap-1">
              <Nav.Link href="#home" className="cf-nav-link">Accueil</Nav.Link>
              <Nav.Link href="#steps" className="cf-nav-link">Étapes</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <header className="cf-hero text-center" id="home">
        <div style={{ position: "relative", zIndex: 1 }}>
          <h1 className="cf-hero-title">Passage 8 → 10 chiffres</h1>
          <p className="cf-hero-sub">Mise à jour automatique de vos contacts béninois</p>
        </div>
      </header>

      <div style={{ background: "#fff", paddingTop: "1.5rem", paddingBottom: "0.5rem" }}>
        <Container fluid className="px-3 px-md-4">
          <div className="cf-info-banner mx-auto" style={{ maxWidth: 720 }}>
            <p style={{ marginBottom: "0.5rem", fontWeight: 500 }}>Le passage aux numéros à 10 chiffres crée encore des problèmes :</p>
            <ul>
              <li>Avec <strong>01</strong>, les contacts disparaissent sur WhatsApp.</li>
              <li>Sans le <strong>01</strong>, les appels ne passent pas et les noms ne s'affichent plus.</li>
            </ul>
            <p style={{ marginBottom: "0.4rem" }}>
              <strong>Notre solution :</strong> nous conservons l'ancien numéro (8 chiffres) et le nouveau (10 chiffres) sous le même nom, sans élargir le nombre de contacts dans le répertoire.
            </p>
            <p style={{ marginBottom: "0.4rem" }}>Vos contacts restent visibles dans WhatsApp et les noms s'affichent correctement lors des appels.</p>
            <p style={{ marginBottom: "0.4rem" }}>
              <span className="badge-ok">✓ Résultat</span>&nbsp;{" "}
              <span className="cf-zero-perte">Zéro perte, zéro confusion, tout fonctionne.</span>
            </p>

            <hr style={{ margin: "0.8rem 0" }} />

            <div
              style={{
                background: "#f5f8ff",
                borderRadius: "10px",
                padding: "0.7rem 1rem",
                fontSize: "0.9rem",
                fontWeight: 500,
                color: "#1e293b",
              }}
            >
              Les <strong>50 premiers contacts</strong> sont mis à jour gratuitement. 
              Au‑delà, téléchargez tous vos contacts <strong>mis à jour</strong> pour 
              <span
                style={{
                  background: "#fef3c7",
                  padding: "1px 8px",
                  borderRadius: "20px",
                  fontWeight: 700,
                  color: "#92400e",
                  marginLeft: "4px",
                }}
              >
                700 FCFA
              </span>.
            </div>
          </div>
        </Container>
      </div>

      <section style={{ padding: "2rem 0 1rem" }} id="steps">
        <Container fluid className="px-3 px-md-4">
          <h2 className="cf-section-title">Étapes à suivre</h2>
          <div className="d-none d-md-block">
            <Row className="g-3 justify-content-center" style={{ maxWidth: 860, margin: "0 auto" }}>
              {steps.map((s, i) => (
                <Col md={3} key={i} className="position-relative">
                  {i < 3 && (
                    <span className="cf-chevron">
                      <FaChevronRight size={20} color="#004aad" />
                    </span>
                  )}
                  <div className="cf-step-card">
                    <div className="cf-step-icon">{s.icon}</div>
                    <p className="cf-step-label mb-0">{s.label}</p>
                    <p className="cf-step-desc mt-1">{s.desc}</p>
                    {s.btn}
                  </div>
                </Col>
              ))}
            </Row>
          </div>
          <div className="d-block d-md-none">
            <Row className="g-2 justify-content-center" style={{ maxWidth: 480, margin: "0 auto" }}>
              {[steps[0], steps[1]].map((s, i) => (
                <Col xs={6} key={i} className="position-relative">
                  {i === 0 && (
                    <span style={{ position: "absolute", right: -16, top: "50%", transform: "translateY(-50%)", zIndex: 2 }}>
                      <FaChevronRight size={18} color="#004aad" />
                    </span>
                  )}
                  <div className="cf-step-card">
                    <div className="cf-step-icon">{s.icon}</div>
                    <p className="cf-step-label mb-0">{s.label}</p>
                    <p className="cf-step-desc mt-1">{s.desc}</p>
                    {s.btn}
                  </div>
                </Col>
              ))}
              <Col xs={12} className="text-center py-1" style={{ paddingLeft: "50%" }}>
                <FaChevronDown size={24} color="#004aad" />
              </Col>
              <Col xs={6} className="position-relative">
                <div className="cf-step-card">
                  <div className="cf-step-icon"><FaClipboardList size={22} color="#fff" /></div>
                  <p className="cf-step-label mb-0">Étape 4</p>
                  <p className="cf-step-desc mt-1">Enrégistrez dans votre téléphone</p>
                  <button className="cf-btn-outline mt-1" onClick={() => setShowModal1(true)} style={{ fontSize: "0.73rem", padding: "3px 12px" }}>Instructions</button>
                </div>
              </Col>
              <Col xs={6} className="position-relative">
                <span style={{ position: "absolute", left: -16, top: "50%", transform: "translateY(-50%)", zIndex: 2 }}>
                  <FaChevronLeft size={18} color="#004aad" />
                </span>
                <div className="cf-step-card">
                  <div className="cf-step-icon"><FaDownload size={22} color="#fff" /></div>
                  <p className="cf-step-label mb-0">Étape 3</p>
                  <p className="cf-step-desc mt-1">Téléchargez</p>
                  <button className="cf-btn-outline mt-1" onClick={() => setShowModal3(true)} style={{ fontSize: "0.73rem", padding: "3px 12px" }}>Instructions</button>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>

      <section style={{ padding: "1.5rem 0 2rem" }}>
        <Container fluid className="px-3 px-md-4" style={{ maxWidth: 860 }}>
          <h2 className="cf-section-title"> Ajoutez votre fichier de contact</h2>
          <div className="cf-upload-card mb-4">
            <div className="cf-file-input">
              <Form.Control
                type="file"
                accept=".csv,.vcf"
                onChange={handleFileChange}
                size="sm"
                style={{ marginBottom: "0.6rem" }}
              />
              <p style={{ fontSize: "0.75rem", color: "var(--cf-muted)", marginBottom: "1rem" }}>Formats acceptés : CSV ou VCF</p>
            </div>
            <button
              className="cf-btn-primary"
              onClick={processFile}
              disabled={isAnalyzing || !file}
            >
              {isAnalyzing
                ? <><Spinner size="sm" className="me-1" />Analyse en cours…</>
                : "Analyser les contacts"}
            </button>
          </div>

          {hasAnalyzed && <div>
            <h3 style={{ fontFamily: "'Fraunces',serif", fontWeight: 700, fontSize: "clamp(0.95rem,3.5vw,1.1rem)", color: "var(--cf-text)", marginBottom: "0.9rem" }}>
              Aperçu des modifications ({previewData.length} contact{previewData.length > 1 ? "s" : ""})
            </h3>
            <p style={{ marginBottom: "0.75rem" }}><span className="badge-info">ℹ️ Info :</span>&nbsp; Les numéros internationaux ne sont pas concernés par la mise à jour.</p>
              {previewData.length > 0 ? (
                <>
                  <div style={{ maxHeight: '400px', overflowY: 'auto', paddingRight: '5px' }}>
                    <Row className="g-2">
                      {(showAllPreview ? previewData : previewData.slice(0, 3)).map((entry, idx) => (
                        <Col xs={12} sm={6} md={4} key={idx}>
                          <div className="cf-contact-card">
                            <p className="cf-contact-name">{entry.name}</p>
                            <p className="cf-contact-old"><strong>Ancien :</strong> {entry.oldNumber}</p>
                            {entry.newNumber != null && entry.newNumber !== "" && (
                              <p className="cf-contact-new"><strong>Nouveau :</strong> {entry.newNumber}</p>
                            )}
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </div>
                  {previewData.length > 3 && (
                    <div style={{ textAlign: "center", marginTop: "0.9rem" }}>
                      <button
                        className="cf-btn-outline"
                        onClick={() => setShowAllPreview(v => !v)}
                        style={{ fontSize: "0.78rem", padding: "0.3rem 1.2rem", display: "inline-flex", alignItems: "center", gap: "0.4rem" }}
                      >
                        {showAllPreview
                          ? <><FaChevronDown size={11} style={{ transform: "rotate(180deg)" }} /> Réduire</>
                          : <><FaChevronDown size={11} /> Voir les {previewData.length - 3} autres contacts</>}
                      </button>
                    </div>
                  )}
                </>
              ) : (
                <p style={{ textAlign: "center", color: "var(--cf-muted)", fontSize: "0.85rem" }}>Aucun contact à afficher.</p>
              )}
          </div>}

          {modificationCount > 0 && showDownloadOptions && (
            <div className="cf-download-banner mt-4">
              <div className="d-flex align-items-center justify-content-center gap-2 mb-2">
                <FaCheckCircle color="var(--cf-success)" size={18} />
                <span>
                  <span className="cf-download-count">{modificationCount}</span>{" "}
                  <span style={{ fontSize: "0.9rem", color: "var(--cf-text)", fontWeight: 500 }}>
                    contact{modificationCount > 1 ? "s" : ""} prêt{modificationCount > 1 ? "s" : ""} à télécharger
                  </span>
                </span>
              </div>
               {/* Validation de consultation */}
                {previewData.length > 3 && !showAllPreview && (
                  <p className="text-start text-sm-center" style={{ color: "#92400e", fontSize: "clamp(0.75rem, 2.5vw, 0.85rem)", marginTop: "0.5rem" }}>
                    Veuillez cliquer sur <strong>« Voir les {previewData.length - 3} autres contacts »</strong> ci‑dessus pour consulter l’intégralité des modifications avant de pouvoir télécharger.
                  </p>
                )}

                {(previewData.length <= 3 || showAllPreview) && (
                  <div className="mt-3 mb-3 d-flex align-items-center gap-2 justify-content-center">
                    <Form.Check
                      type="checkbox"
                      id="confirm-view"
                      label="J’ai vérifié toutes les modifications affichées et j’accepte les mises à jour"
                      checked={hasConfirmedView}
                      onChange={(e) => setHasConfirmedView(e.target.checked)}
                      disabled={previewData.length > 3 && !showAllPreview}
                    />
                  </div>
                )}
              <div className="d-flex gap-2 justify-content-center flex-wrap">
                <button
                    className="cf-btn-outline"
                    onClick={() => {
                        if (!hasConfirmedView) {
                            Swal.fire({
                                icon: 'warning',
                                title: 'Confirmation requise',
                                text: 'Veuillez cocher la case « J’ai vérifié toutes les modifications affichées et j’accepte les mises à jour » avant de télécharger.',
                                confirmButtonColor: '#004aad'
                            });
                            return;
                        }
                        handleFreeDownload();
                    }}
                >
                    <FaDownload size={11} style={{ marginRight: 5 }} />
                    {modificationCount <= 50 ? "Télécharger" : "Version gratuite (50 contacts)"}
                </button>
                {modificationCount > 50 && (
                    hasConfirmedView ? (
                        <FedaCheckoutButton options={checkoutButtonOptions} />
                    ) : (
                        <button
                            className="cf-btn-success"
                            style={{ opacity: 0.6 }}
                            onClick={() => {
                                Swal.fire({
                                    icon: 'warning',
                                    title: 'Confirmation requise',
                                    text: 'Veuillez cocher la case « J’ai vérifié toutes les modifications affichées et j’accepte les mises à jour » avant de procéder au paiement.',
                                    confirmButtonColor: '#004aad'
                                });
                            }}
                        >
                            Télécharger tout (700 FCFA)
                        </button>
                    )
                )}
              </div>
              <p className="cf-format-hint">
                <FaFileAlt size={11} style={{ marginRight: 5 }} />
                Format disponible : VCF
              </p>
            </div>
          )}
        </Container>
      </section>

      {/* <Container fluid className="px-3 px-md-4" style={{ maxWidth: 860 }}>
        <div className="cf-global-counter">
          <div className="d-flex align-items-center justify-content-center gap-2">
            <FaUsers className="cf-global-counter-icon" color="var(--cf-blue)" />
            <span className="cf-global-counter-number">
              {isLoadingCount ? "..." : globalCount.toLocaleString("fr-FR")}
            </span>
          </div>
          <p className="cf-global-counter-text mb-1">
            personnes ont déjà mis à jour leurs contacts avec ContactFlow
          </p>
        </div>
      </Container> */}

      <footer className="cf-footer">
        <span>&copy; 2026 CINNUEX — Tous droits réservés</span>
        <br />
         <span>Contact: +229 0153171701</span>
      </footer>
      <a href="https://wa.me/2290153171701"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          background: "#25D366",
          borderRadius: "50%",
          width: "55px",
          height: "55px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
          zIndex: 1000
        }}
      >
        <svg fill="white" width="28" height="28" viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15
            -.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075
            -.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059
            -.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52
            .149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52
            -.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51
            -.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372
            -.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074
            .149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625
            .712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413
            .248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
          <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.126 1.532 5.855L.057 23.428
            a.75.75 0 0 0 .916.916l5.573-1.475A11.943 11.943 0 0 0 12 24
            c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818
            a9.818 9.818 0 0 1-5.032-1.384l-.36-.214-3.733.988.997-3.648
            -.234-.374A9.818 9.818 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182
            S21.818 6.57 21.818 12 17.43 21.818 12 21.818z"/>
        </svg>
      </a>

      <Modal show={showModal} onHide={handleCloseModal} size="lg" dialogClassName="cf-modal">
        <Modal.Header closeButton>
          <Modal.Title className="cf-modal .modal-title" style={{ fontFamily: "'Fraunces',serif", fontWeight: 700, fontSize: "clamp(0.95rem,4vw,1.1rem)", color: "var(--cf-blue)" }}>
            Téléchargez votre fichier de contact depuis votre téléphone
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "1rem 1.25rem" }}>
          <Row>
            <Col md={6} className="mb-3 mb-md-0">
              <h5 style={{ fontFamily: "'Fraunces',serif", fontWeight: 700, fontSize: "0.95rem", color: "var(--cf-blue)", marginBottom: "0.6rem" }}>
                <FaMobileAlt style={{ marginRight: 6 }} />Android
              </h5>
              <div className="cf-instr-box">
                <h6>Via l'application Contacts</h6>
                <ul>
                  <li>Ouvrez l'application <strong>Contacts</strong> de votre téléphone.</li>
                  <li>Accédez au menu <strong>Paramètres</strong> ou aux <strong>⋮</strong> (3 points).</li>
                  <li>Cherchez l'option <strong>Exporter</strong> ou <strong>Importer/Exporter</strong>.</li>
                  <li>Sélectionnez <strong>Exporter vers un fichier</strong> ou <strong>vers le stockage</strong>.</li>
                  <li>Choisissez le compte source et enregistrez en <code>.VCF</code>.</li>
                </ul>
                <h6>Via Google Contacts</h6>
                <ul>
                  <li>Connectez-vous à <a href="https://contacts.google.com" target="_blank" rel="noopener noreferrer"><FaLink style={{ marginRight: 3 }} />Google Contacts</a>.</li>
                  <li>Sélectionnez les contacts ou cliquez sur <em>Tout sélectionner</em>.</li>
                  <li>Cliquez sur Exporter.</li>
                  <li>Choisissez <code>.VCF</code> ou <code>.CSV</code> et téléchargez.</li>
                </ul>
              </div>
            </Col>
            <Col md={6}>
              <h5 style={{ fontFamily: "'Fraunces',serif", fontWeight: 700, fontSize: "0.95rem", color: "var(--cf-blue)", marginBottom: "0.6rem" }}>
                <FaApple style={{ marginRight: 6 }} />iOS
              </h5>
              <div className="cf-instr-box">
                <h6>Via iCloud</h6>
                <ul>
                  <li>Réglages &gt; [Votre nom] &gt; iCloud → activer Contacts.</li>
                  <li>Allez sur <a href="https://www.icloud.com" target="_blank" rel="noopener noreferrer"><FaLink style={{ marginRight: 3 }} />iCloud.com</a>.</li>
                  <li>Cliquez sur Contacts.</li>
                  <li>Sélectionnez et cliquez sur <em>Exporter une vCard</em>.</li>
                  <li>Téléchargez le fichier <code>.VCF</code>.</li>
                </ul>
                <h6>Application tierce</h6>
                <ul>
                  <li>Téléchargez <em>My Contacts Backup</em>.</li>
                  <li>Effectuez une sauvegarde.</li>
                  <li>Envoyez le fichier par e-mail.</li>
                </ul>
              </div>
            </Col>
          </Row>
          <hr style={{ margin: "1.2rem 0 1rem" }} />
          <div style={{
            background: "var(--cf-blue-light, #eef4fb)",
            border: "1px solid var(--cf-blue)",
            borderRadius: "8px",
            padding: "0.85rem 1rem"
          }}>
            <h5 style={{ fontFamily: "'Fraunces',serif", fontWeight: 700, fontSize: "0.95rem", color: "var(--cf-blue)", marginBottom: "0.5rem" }}>
              <FaUpload style={{ marginRight: 6 }} />
              Étape suivante : Ajouter votre fichier sur la plateforme
            </h5>
            <ol style={{ marginBottom: 0, paddingLeft: "1.2rem", fontSize: "0.88rem" }}>
              <li>Une fois votre fichier télécharger, revenez sur la plateforme.</li>
              <li>Dans la section <strong>« Ajoutez votre fichier de contact »</strong>, cliquez sur <strong>« Choisir un fichier »</strong>.</li>
              <li>Sélectionnez le fichier de contacts que vous venez de télécharger (<code>.VCF</code> ou <code>.CSV</code>).</li>
              <li>Cliquez sur <strong>« Analyser les contacts »</strong> pour lancer l'analyse.</li>
            </ol>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="cf-btn-outline" onClick={handleCloseModal}>Fermer</button>
        </Modal.Footer>
      </Modal>

      <Modal show={showModal1} onHide={handleCloseModal1} size="lg" dialogClassName="cf-modal">
        <Modal.Header closeButton>
          <Modal.Title style={{ fontFamily: "'Fraunces',serif", fontWeight: 700, fontSize: "clamp(0.95rem,4vw,1.1rem)", color: "var(--cf-blue)" }}>
            Mettez à jour vos contacts sur votre téléphone
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "1rem 1.25rem" }}>
          <Row>
            <Col md={6} className="mb-3 mb-md-0">
              <h5 style={{ fontFamily: "'Fraunces',serif", fontWeight: 700, fontSize: "0.95rem", color: "#10b981", marginBottom: "0.6rem" }}>
                <FaMobileAlt style={{ marginRight: 6 }} />Android
              </h5>
              <div className="cf-instr-box">
                <ol style={{ paddingLeft: "1.2rem", marginBottom: "0.5rem" }}>
                  <li>Ouvrez l'application <strong>Contacts</strong>.</li>
                  <li>Appuyez sur les <strong>⋮</strong> (3 points) ou <strong>Paramètres</strong>.</li>
                  <li>Choisissez <strong>Importer</strong> puis <strong>Depuis un fichier</strong> (ou "Depuis le stockage").</li>
                  <li>
                    Dans l'explorateur, ouvrez le dossier <strong>Téléchargements</strong>.<br />
                    <span style={{ color: "var(--cf-muted)", fontSize: "0.85rem" }}>
                      ↳ C'est l'emplacement par défaut où votre fichier modifié a été sauvegardé.
                    </span>
                  </li>
                  <li>Sélectionnez votre fichier <code>.VCF</code> et validez l'importation.</li>
                </ol>
                <p style={{ fontSize: "0.75rem", color: "var(--cf-muted)", marginBottom: 0 }}>
                  <strong>Astuce :</strong> Les libellés peuvent varier selon les marques et modèles de téléphone, mais le chemin reste identique.
                </p>
              </div>
            </Col>

            <Col md={6}>
              <h5 style={{ fontFamily: "'Fraunces',serif", fontWeight: 700, fontSize: "0.95rem", color: "#0ea5e9", marginBottom: "0.6rem" }}>
                <FaApple style={{ marginRight: 6 }} />iOS
              </h5>
              <div className="cf-instr-box">
                <ol style={{ paddingLeft: "1.2rem", marginBottom: "0.5rem" }}>
                  <li>
                    Ouvrez l'application <strong>Fichiers</strong> et accédez au dossier <strong>Téléchargements</strong>.<br />
                    <span style={{ color: "var(--cf-muted)", fontSize: "0.85rem" }}>
                      ↳ C'est ici que votre fichier modifié a été sauvegardé par défaut.
                    </span>
                  </li>
                  <li>Cliquez sur le fichier <code>.VCF</code> pour ouvrir l'aperçu des contacts.</li>
                  <li>Appuyez sur <strong>"Ajouter tous les contacts"</strong> (en haut à droite) pour finaliser.</li>
                </ol>
                <p style={{ fontSize: "0.75rem", color: "var(--cf-muted)", marginBottom: 0 }}>
                  <strong>Astuce :</strong> Le format <code>.VCF</code> garantit un import fluide et sans erreur sur iPhone.
                </p>
              </div>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <button className="cf-btn-outline" onClick={handleCloseModal1}>Fermer</button>
        </Modal.Footer>
      </Modal>

      <Modal show={showModal2} onHide={handleCloseModal2} size="lg" dialogClassName="cf-modal">
        <Modal.Header closeButton>
          <Modal.Title style={{ fontFamily: "'Fraunces',serif", fontWeight: 700, fontSize: "clamp(0.95rem,4vw,1.1rem)", color: "var(--cf-blue)" }}>
            Comprendre l’aperçu des contacts
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "1rem 1.25rem" }}>
          <p style={{ marginBottom: "0.75rem", fontWeight: 500, fontSize: "0.95rem" }}>
            Après  Analyse et mis à jour du fichier des contacts,vous pourrez consulter l'aperçu des modifications avant de télécharger.        </p>
          <div className="cf-instr-box">
            <h6>Que montre l’aperçu ?</h6>
            <ul>
              <li><strong>Ancien numéro</strong> : le numéro tel qu’il figurait dans votre fichier d’origine (8 chiffres).</li>
              <li><strong>Nouveau numéro</strong> : le numéro converti au format <code>+22901XXXXXXXX</code> (10 chiffres).</li>
              <li>Cette opération ne s’applique qu’aux numéros béninois.</li>
            </ul>
            <h6>À savoir</h6>
            <ul>
              <li>Les numéros déjà au bon format ne sont pas affichés dans la liste.</li>
              <li>L’aperçu ne modifie pas votre fichier original – c’est une simulation.</li>
              <li>Vous pouvez cliquer sur <strong>“Voir les X autres contacts”</strong> pour afficher toute la liste.</li>
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="cf-btn-outline" onClick={handleCloseModal2}>Fermer</button>
        </Modal.Footer>
      </Modal>
      
      <Modal show={showModal3} onHide={handleCloseModal3} size="lg" dialogClassName="cf-modal">
        <Modal.Header closeButton>
          <Modal.Title style={{ fontFamily: "'Fraunces',serif", fontWeight: 700, fontSize: "clamp(0.95rem,4vw,1.1rem)", color: "var(--cf-blue)" }}>
            Télécharger vos contacts mis à jour
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "1rem 1.25rem" }}>
          <div className="cf-instr-box">
            <h6>Options de téléchargement</h6>
            <ul>
              <li><strong>Gratuit (≤ 50 contacts)</strong> : téléchargez un fichier contenant  50  contacts modifiés. Vous choisissez le format CSV ou VCF.</li>
              <li><strong>Payant (plus de 50 contacts)</strong> : débloquez l’intégralité des contacts pour 700 FCFA. Après paiement, vous pourrez télécharger tous les contacts modifiés dans le format de votre choix.</li>
            </ul>
            <h6>Formats disponibles</h6>
            <ul>
              <li><strong>CSV</strong> : idéal pour une réimportation dans Google Contacts ou Excel.</li>
              <li><strong>VCF (vCard)</strong> : recommandé pour une importation directe sur Android / iOS.</li>
            </ul>
            <h6>Important</h6>
            <ul>
              <li>Le fichier téléchargé conserve à la fois l’ancien numéro (8 chiffres) et le nouveau numéro (10 chiffres) sous un même  nom.</li>
              <li>Ainsi, vos contacts restent compatibles avec WhatsApp et les appels sans perte d’affichage du nom.</li>
            </ul>
            <p style={{ marginBottom: 0, marginTop: '0.5rem' }}>
              <span className="badge-ok">✓ Résultat garanti:</span>  Zéro perte, zéro confusion.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="cf-btn-outline" onClick={handleCloseModal3}>Fermer</button>
        </Modal.Footer>
      </Modal>
    </>
  );
}